import SkeletonProposal from './SkeletonProposal'
import SkeletonsInputs from './SkeletonsInputs'
import SkeletonTextLine from './SkeletonTextLine/SkeletonTextLine'

export default {
  SkeletonProposal,
  SkeletonsInputs,
  SkeletonTextLine
}
